import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PanelBarComponent, PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { timer } from 'rxjs';
import { AddressType, IBaseResponse, ICheckOutLabel, IcheckoutOrderDetails, ICheckOutResponse, ICustomer, ICustomerAddress, ICustomerShipTo, IOrderDetail, IUser } from 'src/app/core/models';
import { CartService } from 'src/app/core/services/cart.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { UserService } from 'src/app/core/services/user.service';
import { CheckoutService } from '../../core/services/checkout.service';
import { HelperService } from '../../core/services/helper.service';
import { LanguageTranslationService } from '../../core/services/language-translation.service';

declare const gtag: Function;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
  hasPlaceOrderAccess: boolean;
  scrHeight: any;
  scrWidth: any;
  isMobileOrTab: boolean;
  hideShippingAddrGrid: boolean = true;
  constructor(private checkoutService: CheckoutService,
    private userService: UserService,
    private cartService: CartService, private languageTranslationService: LanguageTranslationService,
    private helperService: HelperService,
    private sanitizer: DomSanitizer,  ) {
    this.getScreenSize();
  }

  public get currentShipping(): ICustomer {
    return this.checkoutService.checkOutProcessModel.currentShipping as ICustomer;
  }
  public get currentBilling(): ICustomer {
    return this.checkoutService.checkOutProcessModel.currentBilling as ICustomer;
  }

  public get checkOutState() {
    return this.checkoutService.checkoutformState;
  }

  public get loggedInUser(): IUser {
    return this.userService.readUserObject;
  }
  public orderInProcess: boolean = false;
  public orderInProcessCC: boolean = false;
  public isSystemUserAdmin: boolean = false;
  lblText: ICheckOutLabel;
  //public expandMode: number = PanelBarExpandMode.Default;
  //#region Other Require Refactor
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;

  //@ViewChild('panelbar', { static: false })
  public panelbar: PanelBarComponent;
  @ViewChild('orderDetailsCheck', { static: false })
  public orderDetails: any;

  public shipptingLbl = 'Shipping';
  public paymentLbl = 'Payments';
  public orderDetailsLbl = 'Order Details';
  public reviewOrderLbl = 'REVIEW & PLACE ORDER';

  public expandedItem: string = this.orderDetailsLbl;//this.shipptingLbl;//this.orderDetailsLbl;
  validForm = false;


  public checkoutOrderError = true;
  public orderDetailsValues: IcheckoutOrderDetails;

  public currentBillingAddressLbl: string;
  public currentShippingAddressLbl: string;
  public currentBillingAddressValue1: string;
  public currentBillingAddressValue2: string;
  public currentBillingAddressValue3: string;
  public currentShippingAddressValue1: string;
  public currentShippingAddressValue2a: string;
  public currentShippingAddressValue2b: string;
  public currentShippingAddressValue3: string;
  public missingFields: string;
  public missingFieldBool: boolean;
  public reviewOrderBool: boolean;
  public confirmOrderBool: boolean;
  public disableConfirmOrder: boolean;
  public defaultAddress: ICustomerShipTo;
  public newShippingAddress: ICustomerShipTo;
  public parentToChildAddress: ICustomerShipTo;
  public cCPaymentConfirmationDialog: boolean = false;
  public creditCardCharge: number = 0;
  public creditCardTotalAmount: number = 0;
  // Need to use these functions later
  // setCheckOutOrderDetailsRequires($event) {

  setOrderDetailsValue($event) {
    this.orderDetailsValues = $event;
  }
  //Need to use these functions later
  //setCheckOutOrderDetailsRequires($event) {
  //  this.checkoutOrderError = $event;
  //  if (!this.checkoutOrderError && this.reviewOrderBool) {
  //    this.disableConfirmOrder = false;
  //    this.missingFieldBool = false;
  //  } else {
  //    this.disableConfirmOrder = true;
  //    if (this.reviewOrderBool) {
  //      this.missingFieldBool = true;
  //    }
  //  }
  // }
  //#endregion

  //#region CheckOut Variable Declaration & Operations
  public checkOut = {
    confirmOrderToPlaceOrder: false,
    currentBillingAddressLbl: 'Current Billing Address:',
    currentBillingAddressValue1: '2762-ROYAL GLASS CO INC',
    currentBillingAddressValue2: '3200 DE LA CRUZ BLVD.',
    currentBillingAddressValue3: 'SANTA CLARA, CA 95054',
    currentShippingAddressLbl: 'Current Shipping Address:',
    currentShippingAddressValue1: '2762-ROYAL GLASS CO INC',
    currentShippingAddressValue2a: '3200 DE LA CRUZ BLVD.',
    currentShippingAddressValue3: 'SANTA CLARA, CA 95054',
    shippingLbl: "Shipping",
    continueLbl: 'Continue',
    orderDetailsLbl: 'Order Details',
    reviewOrderLbl: "REVIEW & PLACE ORDER",
    confirmOrderLbl: 'Confirm Order',
    submitedInfo1: 'Thank you for shopping with us.',
    submitedInfo2: 'Your order has been successfully placed.',
    continueShoppingLbl: 'Continue Shopping!',
    kawneerOrderLbl: 'Your KawneerDirect Order Number',
    kdLbl: 'KD',
    submitedInfo3: 'Sorry we are unable to process your order. Please try again.',
    submitedInfo4: 'If problem persists, please connect to Kawneer Admin',
    closeLbl: 'Close',
    surveyFeedbackLbl: 'Please provide feedback',
    confirmOrderCCLbl: 'Place Order - Charge to Account',
    confirmOrderCCOnlyLbl: 'Place Order - Pay with Credit Card',
  };

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    if (this.scrWidth <= 1024) {
      this.isMobileOrTab = true;
      // this.hideShippingAddrGrid = true;
    }
    else {
      this.isMobileOrTab = false;
      this.hideShippingAddrGrid = false;
    }
  }
  ngOnInit(): void {
    this.loadLanguageTranslationData();
    this.checkOutState.isShippingFormSubmitted = false;
    this.checkOutState.isRCFormSubmitted = false;
    this.checkOutState.isODFormSubmitted = false;
    this.checkoutService.orderDetailsForm.isSubmitted = false;
    this.checkoutService.checkOutProcessModel.orderDetail = {} as IOrderDetail; //clearing the order detail form data
    this.checkoutService.checkOutProcessModel.currentShipping = {} as ICustomer; //clearing the currentShipping from data so it should not override default address.K50-939
    this.checkoutService.checkOutProcessModel.freightAmount = 0;
    this.checkoutService.freightAmountChangeSubject.next(0);
    this.hasPlaceOrderAccess = this.userService.hasAccessToPlaceOrder();
    if (this.userService.isCheckoutCCCustomer())
      this.checkOutCCCustomer = true;
    if (this.userService.isCheckoutCConlyCustomer())
      this.checkOutCConlyCustomer = true;
    if (this.userService.getFreightEstimateFlag())
      this.freightEstimateFlag = true;
  }

  //#endregion
  //#region Language translate
  loadLanguageTranslationData() {
    //need to add remaining fields
    const controlNameList = [
      { controlName: "currentBillingAddressLbl" },
      { controlName: "currentShippingAddressLbl" },
      { controlName: "orderDetailsLbl" },
      { controlName: "paymentLbl" },
      { controlName: "reviewOrderLbl" },
      { controlName: "shippingLbl" },
      { controlName: "continueLbl" },
      { controlName: "confirmOrderLbl" },
      { controlName: "submitedInfo1" },
      { controlName: "submitedInfo2" },
      { controlName: "submitedInfo3" },
      { controlName: "submitedInfo4" },
      { controlName: "continueShoppingLbl" },
      { controlName: "kawneerOrderLbl" },
      { controlName: "kdLbl" },
      { controlName: "closeLbl" },
      { controlName: "surveyFeedbackLbl" }
    ];
    const componentName = "checkout";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.lblText = response[response.length - 1];
      console.log(response);
    }

  }

  //#endregion
  //#region SHIPPING
  public continueToOrderDetails(): void {

    if (this.checkoutService.checkOutProcessModel.currentBilling
      && this.checkoutService.checkOutProcessModel.currentShipping) {
      this.checkOutState.isShippingFormSubmitted = true;
      this.checkOutState.isShippingFormValid = true;
      this.activatePanel(1);
    }
  }

  //#endregion
  //#region ORDER DETAILS
  public continueToReviewOrder(): void {
    this.checkoutService.orderDetailsForm.isSubmitted = true;
    console.log(this.checkoutService.checkOutProcessModel);
    if (this.checkoutService.validateODForm()) {
      this.activatePanel(2);
    }
  }

  //#endregion
  closeConfirmDialog() {
    this.orderAcknowledgementDialog.opened = false;
  }
  //#region ORDER DETAILS
  public placeOrder(): void {
    if (this.checkoutService.checkOutProcessModel.currentBilling
      && this.checkoutService.checkOutProcessModel.currentShipping) { //checking if address panel form is valid or not
      this.checkOutState.isShippingFormSubmitted = true;
      this.checkOutState.isShippingFormValid = true;
    }
    this.checkoutService.orderDetailsForm.isSubmitted = true;
    this.checkOutState.isRCFormSubmitted = true;

    this.checkOutState.isODFormValid = this.checkoutService.validateODForm(); //checking if order details form is valid or not
    if (this.checkOutState.isODFormValid
      && this.checkOutState.isShippingFormValid
      && this.checkOutState.isRCFormValid) {
      this.orderInProcess = true;
      this.activatePanel(-1);//collapse all panel;
      this.checkoutService.confirmCheckout().subscribe((response: IBaseResponse) => {

        //hope everything is successfull & order acknoledge number is received.
        if (!response.isError) {
          this.orderAcknowledgementDialog.opened = true;
          this.orderAcknowledgementDialog.acknowledgeNumber = response.data.toString(); //assign order acknoledge number from response
          this.cartService.totalCartItem.next(0);
          this.orderInProcess = false;
          this.checkoutService.reset();
          try {
            this.sendLogToGoogleAnalytics(this.orderAcknowledgementDialog.acknowledgeNumber);
          }
          catch (e) { }
        } else {
          this.orderAcknowledgementDialog.opened = true;
          this.orderAcknowledgementDialog.isError = true;
          this.orderInProcess = false;
        }

      });

    }
    else {
      this.checkOutState.isShippingFormSubmitted = true;
      this.checkOutState.isRCFormSubmitted = true;
      this.checkOutState.isODFormSubmitted = true;
    }
  }
   //GA implementation 
  sendLogToGoogleAnalytics(kdRefNumber = '') {
    gtag('event', 'Checkout', {
      'event_category': 'Checkout',
      'event_label': 'Checkout Clicked',
      'value': kdRefNumber
    })
  }

  //#endregion
  //#region Order Acknowldegement Dialog
  public orderAcknowledgementDialog = {
    opened: false,
    acknowledgeNumber: "",
    isError: false
  }
  //#endregion
  //#region panel change event
  public activatePanel(index: number) {
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    if (index !== -1) {
      this.panel.childrenItems[index].expanded = true;
      this.panel.childrenItems[index].selected = true;
    }
  }
  public onPanelStateChange(e) {

  }
  //#endregion
  showHideShippingAddress() {
    this.hideShippingAddrGrid = !this.hideShippingAddrGrid;
  }


  //#region Pay with Credit Card and Place order
  checkOutCCCustomer: boolean = false;
  freightEstimateFlag: boolean = false;
  checkOutCConlyCustomer: boolean = false;
  public placeOrderWithChargeToAccount(): void {
    if (this.checkoutService.checkOutProcessModel.currentBilling
      && this.checkoutService.checkOutProcessModel.currentShipping) { //checking if address panel form is valid or not
      this.checkOutState.isShippingFormSubmitted = true;
      this.checkOutState.isShippingFormValid = true;
    }
    this.checkoutService.orderDetailsForm.isSubmitted = true;
    this.checkOutState.isRCFormSubmitted = true;

    this.checkOutState.isODFormValid = this.checkoutService.validateODFormForOrdersPaidWithCC(); //checking if order details form is valid or not
    if (this.checkOutState.isODFormValid
      && this.checkOutState.isShippingFormValid
      && this.checkOutState.isRCFormValid) {
      this.orderInProcess = true;
      this.activatePanel(-1);//collapse all panel;
     

      this.checkoutService.confirmCheckoutChargeToAccount().subscribe((response: IBaseResponse) => {

        //hope everything is successfull & order acknoledge number is received.
        if (!response.isError) {
          this.orderAcknowledgementDialog.opened = true;
          this.orderAcknowledgementDialog.acknowledgeNumber = response.data.toString(); //assign order acknoledge number from response
          this.cartService.totalCartItem.next(0);
          this.orderInProcess = false;
          this.checkoutService.reset();
          try {
            this.sendLogToGoogleAnalytics(this.orderAcknowledgementDialog.acknowledgeNumber);
          }
          catch (e) { }
        } else {
          this.orderAcknowledgementDialog.opened = true;
          this.orderAcknowledgementDialog.isError = true;
          this.orderInProcess = false;
        }

      });

    }
    else {
      this.checkOutState.isShippingFormSubmitted = true;
      this.checkOutState.isRCFormSubmitted = true;
      this.checkOutState.isODFormSubmitted = true;
    }
  }
  public openPaymentWithCCDialog() {
    this.creditCardCharge = 0;
    this.creditCardTotalAmount = 0;
    if (this.checkoutService.checkOutProcessModel.currentBilling
      && this.checkoutService.checkOutProcessModel.currentShipping) { //checking if address panel form is valid or not
      this.checkOutState.isShippingFormSubmitted = true;
      this.checkOutState.isShippingFormValid = true;
    }
    this.checkoutService.orderDetailsForm.isSubmitted = true;
    this.checkOutState.isRCFormSubmitted = true;
    this.checkOutState.isODFormValid = this.checkoutService.validateODFormForOrdersPaidWithCC(); //checking if order details form is valid or not
    if (this.checkOutState.isODFormValid
      && this.checkOutState.isShippingFormValid
      && this.checkOutState.isRCFormValid) {
      this.activatePanel(-1);//collapse all panel;
      this.cCPaymentConfirmationDialog = true;
      this.creditCardCharge = this.checkoutService.checkOutProcessModel.creditCardCharge;
      this.creditCardTotalAmount = this.checkoutService.checkOutProcessModel.orderTotal + this.checkoutService.checkOutProcessModel.freightAmount + this.checkoutService.checkOutProcessModel.creditCardCharge + this.checkoutService.minOrderFee;
    }
    else {
      this.checkOutState.isShippingFormSubmitted = true;
      this.checkOutState.isRCFormSubmitted = true;
      this.checkOutState.isODFormSubmitted = true;
    }
  }
  public ClosePaymentWithCCDialog() {
    this.cCPaymentConfirmationDialog = false;
  }

  public proceedToMakePaymentWithCCAndPlaceOrder() {
    //?? Refactor needed. 
    if (this.checkoutService.checkOutProcessModel.currentBilling
      && this.checkoutService.checkOutProcessModel.currentShipping) { //checking if address panel form is valid or not
      this.checkOutState.isShippingFormSubmitted = true;
      this.checkOutState.isShippingFormValid = true;
    }
    this.checkoutService.orderDetailsForm.isSubmitted = true;
    this.checkOutState.isRCFormSubmitted = true;
    let isSafari = this.helperService.isSafari();
    this.checkoutService.browserName = '';
    if (isSafari) {
      this.checkoutService.browserName = "safari";
    }
    this.checkOutState.isODFormValid = this.checkoutService.validateODFormForOrdersPaidWithCC(); //checking if order details form is valid or not
    if (this.checkOutState.isODFormValid
      && this.checkOutState.isShippingFormValid
      && this.checkOutState.isRCFormValid) {
      this.orderInProcessCC = true;
      this.cCPaymentConfirmationDialog = false;
      this.activatePanel(-1);//collapse all panel;
      /*Handle exception in the call*/
      this.checkoutService.getCreditCardCheckOutRequestId().subscribe((response: any) => {
        //hope everything is successfull & order acknoledge number is received.
        if (!response.isError) {
          this.checkoutService.ccActionUrl = response.actionUrl;
          this.checkoutService.ccRequestId = response.ccPayload.requestId;
          this.checkoutService.ccTrackerId = response.ccPayload.trackerId;
          if (this.checkoutService.browserName == 'safari' && false) {
            window.open(response.actionUrl, '_blank');
          } else {
            this.transform();
            this.openPaymentPortal();
          }
        }
        else {
          //show error to the user
          this.orderInProcessCC = false;
        }
        try {
          this.sendLogToGoogleAnalytics(this.orderAcknowledgementDialog.acknowledgeNumber);
        }
        catch (e) { }
      });
    }
    else {
      this.checkOutState.isShippingFormSubmitted = true;
      this.checkOutState.isRCFormSubmitted = true;
      this.checkOutState.isODFormSubmitted = true;
    }
  }
  openPaymentPortal() {
    this.showPaymentDialog = true;
    this.paymentPortalInitializing = true;
    timer(8000)
      .subscribe(t => { this.paymentPortalInitializing = false });
  }
  closePaymentPortal() {
    this.orderInProcess = false;
    this.showPaymentDialog = false;
    this.paymentPortalInitializing = false;
  }
  paymentPortalInitializing = true;
  showPaymentDialog = false;
  actionUrl: string = "";
  url: any;
  transform() {
    this.actionUrl = this.checkoutService.ccActionUrl;
    if (this.actionUrl) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.actionUrl);
      this.checkoutService.ccActionUrl = "";//url will be used only once
    }
  }
  async cancelOrder() {
    if (this.checkoutService.ccTrackerId) {
      var request = { "trackerId": this.checkoutService.ccTrackerId };
      //do other required steps
      try {
        var paymentResponse = await this.checkoutService.cancelCreditCardCheckout(request).toPromise();
        this.closePaymentPortal();
      }
      catch (e) {
      }
    } else {
      // cancelCreditCardCheckout(data: any)
      this.closePaymentPortal();
    }
  }
  //#endregion

}
